import { useEffect, useState } from "react";

export type CountDownProps = {
    expiryDateTime: Date;
};

export const CountDown = ({ expiryDateTime }: CountDownProps) => {
    const [timeLeft, setTimeLeft] = useState<string>("00:00");

    useEffect(() => {
        const calculateTimeLeft = () => {
            const now = new Date().getTime();
            const expiry = expiryDateTime.getTime();
            const difference = expiry - now;

            if (difference <= 0) {
                setTimeLeft("00:00");
                return;
            }

            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);

            const formattedMinutes = minutes.toString().padStart(2, "0");
            const formattedSeconds = seconds.toString().padStart(2, "0");

            setTimeLeft(`${formattedMinutes}:${formattedSeconds}`);
        };

        calculateTimeLeft();
        const interval = setInterval(calculateTimeLeft, 1000);

        return () => clearInterval(interval);
    }, [expiryDateTime]);

    return <>{timeLeft}</>;
};

